import { IInvoiceTransaction } from "redux/reducers/models/order";

export function refundedDepositAmount(deposit: IInvoiceTransaction, transactions: IInvoiceTransaction[]): number {
  return transactions
    .filter(item => item.kind === "refund" && Number(item.parent_id) === deposit.id)
    .reduce((sum, item) => sum + (Number(item.amount) || 0), 0);
}

export function isFullyRefundedDeposit(deposit: IInvoiceTransaction, transactions: IInvoiceTransaction[]): boolean {
  const refundedAmount = refundedDepositAmount(deposit, transactions);

  return refundedAmount > 0 && refundedAmount >= Number(deposit.amount || 0);
}

/**
 * Deposits for this invoice, plus unapplied deposits that still have a balance.
 * A partial refund stays available. A full refund does not.
 */
export function visibleInvoiceDeposits(
  deposits: IInvoiceTransaction[],
  invoiceId: number | null | undefined,
): IInvoiceTransaction[] {
  return deposits.filter(deposit => {
    if (deposit.kind === "refund" || deposit.kind === "deposit_authorization") {
      return false;
    }

    if (isFullyRefundedDeposit(deposit, deposits)) {
      return false;
    }

    if (deposit.invoice_id === invoiceId) {
      return true;
    }

    const unapplied = deposit.invoice_id === null || deposit.invoice_id === undefined;

    return unapplied && Number(deposit.amount_remaining) > 0;
  });
}

/** Amount that will be, or already was, credited to an invoice. */
export function depositAmountToShow(deposit: IInvoiceTransaction, transactions: IInvoiceTransaction[]): number {
  const net = Math.max(0, (Number(deposit.amount) || 0) - refundedDepositAmount(deposit, transactions));

  if (deposit.invoice_id != null) {
    return net;
  }

  if (deposit.amount_remaining !== null && deposit.amount_remaining !== undefined) {
    return Number(deposit.amount_remaining);
  }

  return net;
}
